(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kc-carousel')) {
    customElements.define(
      'kc-carousel',
      class KcCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-kc-track]');
          if (!this.track) return;

          this.prevBtn = this.querySelector('[data-kc-prev]');
          this.nextBtn = this.querySelector('[data-kc-next]');
          this.thumb = this.querySelector('[data-kc-thumb]');
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.inEditor = !!(window.Shopify && window.Shopify.designMode);
          this.paused = false;
          this.visible = false;
          this.frame = null;

          this.update = this.update.bind(this);
          this.queueUpdate = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };

          this.track.addEventListener('scroll', this.queueUpdate, { passive: true });
          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(this.queueUpdate);
            this.resizeObserver.observe(this.track);
          }

          this.initDrag();
          this.initAutoplay();

          if (this.inEditor) {
            this.addEventListener('shopify:block:select', (event) => {
              const slide = event.target.closest('[data-kc-slide]');
              if (!slide) return;
              this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
            });
          }

          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.viewObserver) this.viewObserver.disconnect();
          clearInterval(this.timer);
          cancelAnimationFrame(this.frame);
        }

        get maxScroll() {
          return this.track.scrollWidth - this.track.clientWidth;
        }

        get position() {
          return Math.abs(this.track.scrollLeft);
        }

        update() {
          const max = this.maxScroll;
          const pos = this.position;
          const isStatic = max <= 2;

          this.classList.toggle('is-static', isStatic);
          if (this.prevBtn) this.prevBtn.disabled = pos <= 2;
          if (this.nextBtn) this.nextBtn.disabled = pos >= max - 2;

          if (this.thumb && !isStatic) {
            const total = this.track.scrollWidth;
            this.thumb.style.width = (this.track.clientWidth / total) * 100 + '%';
            this.thumb.style.left = (pos / total) * 100 + '%';
          }
        }

        /* Move by a page of cards, or by a single card when count is 1 */
        step(direction, count) {
          const slide = this.track.querySelector('[data-kc-slide]');
          if (!slide) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const unit = slide.getBoundingClientRect().width + gap;
          const perPage = Math.max(1, Math.floor((this.track.clientWidth + gap) / unit));
          this.track.scrollBy({
            left: direction * unit * (count || perPage),
            behavior: this.reduceMotion ? 'auto' : 'smooth',
          });
        }

        /* Click and drag with a mouse; touch devices use native swiping */
        initDrag() {
          const track = this.track;
          let down = false;
          let moved = false;
          let startX = 0;
          let startLeft = 0;

          track.addEventListener('pointerdown', (event) => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;
            down = true;
            moved = false;
            startX = event.clientX;
            startLeft = track.scrollLeft;
          });

          track.addEventListener('pointermove', (event) => {
            if (!down) return;
            const delta = event.clientX - startX;
            if (!moved && Math.abs(delta) > 6) {
              moved = true;
              track.classList.add('is-dragging');
              track.setPointerCapture(event.pointerId);
            }
            if (moved) track.scrollLeft = startLeft - delta;
          });

          const end = () => {
            if (!down) return;
            down = false;
            if (!moved) return;
            track.classList.remove('is-dragging');
            /* Settle on the nearest card */
            const slide = track.querySelector('[data-kc-slide]');
            if (!slide) return;
            const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
            const unit = slide.getBoundingClientRect().width + gap;
            const target = Math.min(this.maxScroll, Math.round(track.scrollLeft / unit) * unit);
            track.scrollTo({ left: target, behavior: this.reduceMotion ? 'auto' : 'smooth' });
          };
          track.addEventListener('pointerup', end);
          track.addEventListener('pointercancel', end);

          /* Stop a drag from also following the card link */
          track.addEventListener(
            'click',
            (event) => {
              if (!moved) return;
              event.preventDefault();
              event.stopPropagation();
              moved = false;
            },
            true
          );
          track.addEventListener('dragstart', (event) => event.preventDefault());
        }

        initAutoplay() {
          if (this.dataset.autoplay !== 'true' || this.reduceMotion || this.inEditor) return;
          const delay = Math.max(2, parseInt(this.dataset.speed, 10) || 5) * 1000;

          const pause = () => (this.paused = true);
          const resume = () => (this.paused = false);
          this.addEventListener('mouseenter', pause);
          this.addEventListener('mouseleave', resume);
          this.addEventListener('focusin', pause);
          this.addEventListener('focusout', resume);
          this.addEventListener('touchstart', pause, { passive: true });
          this.addEventListener('touchend', resume, { passive: true });

          if ('IntersectionObserver' in window) {
            this.viewObserver = new IntersectionObserver(
              (entries) => {
                this.visible = entries[0].isIntersecting;
              },
              { threshold: 0.4 }
            );
            this.viewObserver.observe(this);
          } else {
            this.visible = true;
          }

          this.timer = setInterval(() => {
            if (this.paused || !this.visible || document.hidden) return;
            if (this.maxScroll <= 2) return;
            if (this.position >= this.maxScroll - 2) {
              this.track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              this.step(1, 1);
            }
          }, delay);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
